import { EventHandler } from '@/components/Tables/toast/helpers';

export const ToastEventHandler = new EventHandler();
